//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QlikCollapsableFilter from './QlikCollapsableFilter'
import PlusMinusIcon from '~sdp-components/Icons/PlusMinusIcon'

export default {
  components: {
    PlusMinusIcon,
    QlikCollapsableFilter
  },
  props: {
    // required
    // { field, label, ?hideExcluded}
    fieldValues: {
      type: Array,
      required: true
    },

    // optional
    /**
     * If true, this container will add new fields that user selects through
     * some other qlik object (e.g. a visualization).
     * To prevent specific fields from appearing, use excludedFields prop
     */
    allowAltFields: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * A simple array of fields that should not be displayed here
     */
    excludedFields: {
      type: Array,
      required: false,
      default: () => []
    },

    title: {
      type: String,
      required: false,
      default: 'Filters'
    },
    preventCollapse: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Set to true if we want to show all values regardless of excluded status
     * in full color font
     */
    preventExclusionStyle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      // altFieldValues are for fields that were not given as props
      altFieldValues: [],
      fieldsWithSelections: [],
      showFilters: false,
      sessionObject: null
    }
  },
  computed: {
    allFieldValues() {
      return this.fieldValues.concat(this.altFieldValues)
    },
    hasSelections() {
      return this.fieldsWithSelections.length > 0
    }
  },
  async mounted() {
    try {
      // this is in case we do a page refresh
      if (this.sessionObject) {
        await this.removeQlikListeners()
        this.fieldsWithSelections = []
      }
      // create a session object that will respond to user selections, will use the update methods to get changes
      this.sessionObject = await this.$qlik.generateSessionLists()
      this.sessionObject.on('changed', this.handleChange)
      this.update()
    } catch (err) {
      console.log('error in QlikCollapsableFilterContainer: initialize', err)
    }
  },
  destroyed() {
    this.removeQlikListeners()
  },
  methods: {
    clearSelections() {
      this.fieldsWithSelections.forEach(field => {
        try {
          this.$qlik.clearField(field)
        } catch (error) {
          console.log(
            'error in QlikCollapsableFilter: clearSelections',
            error,
            field
          )
        }
      })
      // hide the filter pane
      this.showFilters = false
    },

    /**
     * Handles any selection made by the user, including fields that are not filters
     */
    async handleChange() {
      const selectionsByField = await this.update()
      this.$emit('change', selectionsByField)
    },

    async removeQlikListeners() {
      if (this.sessionObject) {
        await this.sessionObject.removeListener('changed', this.handleChange)
        return await this.$qlik.destroySessionObject(this.sessionObject)
      } else {
        return false
      }
    },

    /**
     * Get current selections, update "fieldsWithSelections", and add any new fields to the altFieldValues array.
     */
    async update() {
      const selectionsByField = await this.$qlik.getCurrentSelectionsFromSessionLists(
        this.sessionObject
      )
      let fieldsWithSelections
      if (this.allowAltFields) {
        // do not add fields on the blacklist
        fieldsWithSelections = Object.keys(selectionsByField).filter(field => {
          const fieldName =
            typeof field === 'string' ? field : field?.field || ''
          return !this.excludedFields
            .map(_field =>
              typeof _field === 'string' ? _field : _field?.field || ''
            )
            .includes(fieldName)
        })
      } else {
        // only add fields that are part of the prop fields
        const fields = this.fieldValues.map(f => f.field)
        fieldsWithSelections = Object.keys(selectionsByField).filter(f =>
          fields.includes(f)
        )
      }
      // if there are available field selections open this panel
      if (fieldsWithSelections?.length > 0) this.showFilters = true
      this.fieldsWithSelections = fieldsWithSelections

      // add any fields not in the props fields to the alt fields (if not already there and permitted)
      if (this.allowAltFields) {
        let label
        this.fieldsWithSelections.forEach(field => {
          if (
            !this.allFieldValues.map(f => f.field).includes(field) &&
            !this.excludedFields.includes(field)
          ) {
            label = field.replace('_', ' ')
            this.altFieldValues.push({ field, label })
          }
        })
      }

      return selectionsByField
    }
  }
}
